import { ForumMessage } from './ForumMessage.class';
/**
 * Citation d'un message sur le forum
 */
export class Citation {
    /**
     * Constructeur de la citation
     * @param citationObj à construire
     */
    constructor(citationObject) {
        var _a;
        if (citationObject) {
            const { idCitation, idMembre, messageOrigine, message, dateEnregistrement, pseudo, idMessageOrigine } = citationObject;
            this.idCitation = idCitation !== null && idCitation !== void 0 ? idCitation : null;
            this.idMembre = idMembre !== null && idMembre !== void 0 ? idMembre : null;
            this.messageOrigine = (_a = new ForumMessage(messageOrigine)) !== null && _a !== void 0 ? _a : null;
            this.idMessageOrigine = idMessageOrigine !== null && idMessageOrigine !== void 0 ? idMessageOrigine : null;
            this.message = message !== null && message !== void 0 ? message : null;
            this.dateEnregistrement = dateEnregistrement !== null && dateEnregistrement !== void 0 ? dateEnregistrement : null;
            this.pseudo = pseudo !== null && pseudo !== void 0 ? pseudo : null;
        }
    }
    /**
     * Méthode de renvoie de l'objet en back sous la forme d'un tableau
     * @return array
     */
    toRaw() {
        return {
            idCitation: this.idCitation,
            idMembre: this.idMembre,
            idMessageOrigine: this.idMessageOrigine,
            message: this.message,
            dateEnregistrement: this.dateEnregistrement,
            pseudo: this.pseudo,
        };
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2l0YXRpb24uY2xhc3MuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJDaXRhdGlvbi5jbGFzcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsWUFBWSxFQUFFLE1BQU0sc0JBQXNCLENBQUM7QUFFcEQ7O0dBRUc7QUFDSCxNQUFNLE9BQU8sUUFBUTtJQXlDcEI7OztPQUdHO0lBQ0gsWUFBbUIsY0FBa0M7O1FBQ3BELElBQUksY0FBYyxFQUFFO1lBQ25CLE1BQU0sRUFBRSxVQUFVLEVBQUUsUUFBUSxFQUFFLGNBQWMsRUFBRSxPQUFPLEVBQUUsa0JBQWtCLEVBQUUsTUFBTSxFQUFFLGdCQUFnQixFQUFFLEdBQ3BHLGNBQWMsQ0FBQztZQUVoQixJQUFJLENBQUMsVUFBVSxHQUFHLFVBQVUsYUFBVixVQUFVLGNBQVYsVUFBVSxHQUFJLElBQUksQ0FBQztZQUNyQyxJQUFJLENBQUMsUUFBUSxHQUFHLFFBQVEsYUFBUixRQUFRLGNBQVIsUUFBUSxHQUFJLElBQUksQ0FBQztZQUNqQyxJQUFJLENBQUMsY0FBYyxHQUFHLE1BQUEsSUFBSSxZQUFZLENBQUMsY0FBYyxDQUFDLG1DQUFJLElBQUksQ0FBQztZQUMvRCxJQUFJLENBQUMsZ0JBQWdCLEdBQUcsZ0JBQWdCLGFBQWhCLGdCQUFnQixjQUFoQixnQkFBZ0IsR0FBSSxJQUFJLENBQUM7WUFDakQsSUFBSSxDQUFDLE9BQU8sR0FBRyxPQUFPLGFBQVAsT0FBTyxjQUFQLE9BQU8sR0FBSSxJQUFJLENBQUM7WUFDL0IsSUFBSSxDQUFDLGtCQUFrQixHQUFHLGtCQUFrQixhQUFsQixrQkFBa0IsY0FBbEIsa0JBQWtCLEdBQUksSUFBSSxDQUFDO1lBQ3JELElBQUksQ0FBQyxNQUFNLEdBQUcsTUFBTSxhQUFOLE1BQU0sY0FBTixNQUFNLEdBQUksSUFBSSxDQUFDO1NBQzdCO0lBQ0YsQ0FBQztJQUVEOzs7T0FHRztJQUNJLEtBQUs7UUFDWCxPQUFPO1lBQ04sVUFBVSxFQUFFLElBQUksQ0FBQyxVQUFVO1lBQzNCLFFBQVEsRUFBRSxJQUFJLENBQUMsUUFBUTtZQUN2QixnQkFBZ0IsRUFBRSxJQUFJLENBQUMsZ0JBQWdCO1lBQ3ZDLE9BQU8sRUFBRSxJQUFJLENBQUMsT0FBTztZQUNyQixrQkFBa0IsRUFBRSxJQUFJLENBQUMsa0JBQWtCO1lBQzNDLE1BQU0sRUFBRSxJQUFJLENBQUMsTUFBTTtTQUNuQixDQUFDO0lBQ0gsQ0FBQztDQUNEIn0=